import s from "./WhyUsStrip.module.css";

const items = [
  {
    title: "Made for autographs",
    copy: "Every item picked for how signed prints, photos, and Pops actually need to be displayed and stored.",
    icon: (
      <svg
        width="32"
        height="32"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M12 2 L3 6 V12 a9 9 0 0 0 9 9 a9 9 0 0 0 9 -9 V6 Z" />
        <path d="M9 12 L11 14 L15 10" />
      </svg>
    ),
  },
  {
    title: "Ships in 24 hours",
    copy: "Order today, your protection is on the way tomorrow. Free shipping on orders over $35.",
    icon: (
      <svg
        width="32"
        height="32"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <circle cx="12" cy="12" r="10" />
        <path d="M12 6 V12 L16 14" />
      </svg>
    ),
  },
  {
    title: "UV-safe materials",
    copy: "Acid-free backing, museum-grade acrylic. Your signature stays sharp for the long haul.",
    icon: (
      <svg
        width="32"
        height="32"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M3 12 a9 9 0 1 0 18 0 a9 9 0 0 0 -18 0" />
        <path d="M8 12 L11 15 L16 9" />
      </svg>
    ),
  },
  {
    title: "Real human help",
    copy: "Not sure what fits your 11\u00d714 with COA? Chat with us \u2014 we collect this stuff too.",
    icon: (
      <svg
        width="32"
        height="32"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M4 4 L20 4 L20 16 L13 16 L9 20 L9 16 L4 16 Z" />
        <path d="M8 9 L16 9 M8 12 L13 12" />
      </svg>
    ),
  },
];

export default function WhyUsStrip() {
  return (
    <section className={s.why}>
      <div className={s.inner}>
        {items.map((item) => (
          <div key={item.title} className={s.item}>
            <div className={s.icon}>{item.icon}</div>
            <h3 className={s.title}>{item.title}</h3>
            <p className={s.copy}>{item.copy}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
